import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Localization } from 'libs.localization.common';
import { Locale, Spinner, useLocalizeMessage } from 'libs.nucleus';
import { ButtonWithTooltip, useBooleanState } from 'libs.react';
import { ExportModal } from '../..';
import { useLocalizationExportV2 } from '../../hooks/use_localization_export_v2.hook';
const useExportHandler = (assets, studyId, productVersion) => {
    const { mutate: exportLocalization, isPending: isExporting } = useLocalizationExportV2();
    const getAssetLocaleVersions = useCallback((asset, targetLocales) => {
        const versions = [];
        const assetId = new Localization(asset).getId();
        const matchingAsset = Object.values(assets || {}).find((a) => a?.asset?.id === asset.id && a?.asset?.type === asset.type);
        if (matchingAsset) {
            targetLocales.forEach((locale) => {
                const version = matchingAsset.currentVersionStatus?.[locale]?.version;
                if (version) {
                    versions.push(`${locale}~${version}`);
                }
            });
        }
        return { assetId, versions };
    }, [assets]);
    const handleExport = useCallback((state) => {
        const selectedLocales = state.locale?.selectedLocales || [Locale.en_US];
        const assetVersions = {};
        state.assets?.selectedAssets?.forEach((asset) => {
            const { assetId, versions } = getAssetLocaleVersions(asset, selectedLocales);
            assetVersions[assetId] = versions;
        });
        exportLocalization({
            assets: assetVersions,
            resources: state.content?.resources || [],
            scope: state.scope,
            ...(state.content?.viewport ? { viewport: state.content.viewport } : {}),
            ...(studyId ? { study: studyId } : {}),
            ...(productVersion ? { productVersion } : {}),
        });
    }, [getAssetLocaleVersions, exportLocalization, studyId, productVersion]);
    return { handleExport, isExporting };
};
export const DashboardExportActionV2 = ({ showTooltip, tooltipText, isDisabled, assets, locales, baseLocale, studyId, productVersion, }) => {
    const t = useLocalizeMessage();
    const [isExportModalOpen, openExportModal, closeExportModal] = useBooleanState(false);
    const { handleExport, isExporting } = useExportHandler(assets, studyId, productVersion);
    const handleExportSubmit = useCallback((state) => {
        closeExportModal();
        handleExport(state);
    }, [closeExportModal, handleExport]);
    return (_jsxs(_Fragment, { children: [_jsx(ButtonWithTooltip, { enableTooltip: showTooltip, tooltip: tooltipText, variant: 'secondary', onClick: openExportModal, label: t('Export'), disabled: isDisabled, content: isExporting ? (_jsx("div", { className: 'py-1', children: _jsx(Spinner, { size: 'sm' }) })) : undefined }), isExportModalOpen && (_jsx(ExportModal, { onModalClose: closeExportModal, onHandleExport: handleExportSubmit, assets: assets, locales: locales, baseLocale: baseLocale, isTranslationV2: true }))] }));
};
